import React, { useEffect } from 'react'
import Navbar from './navbar'
import '../assets/style.css'
import image from '../assets/images/vegan.jpg'
import UseGet from '../hooks/useGet'
import UseIncreament from '../hooks/useIncreament'

interface Product{
  id:number | string
  price:number | string
  product:{id:number |string,name:string,images:{image:string}[],price:string}
  quantity:number | string
  user:number |string
}
function Cart() {
  const token = localStorage.getItem('authToken')
  const {data,getData} = token ? UseGet({token}) : {data:[], getData:()=>{}}


useEffect(()=>{
  getData()
console.log(data)
},[])
   const {Increament,Decreament} = UseIncreament()
   const increamentHandler = async (id:number |string,price:string)=>{
    console.log(id,price)
    const tokeValue = token ? token :'';
    await Increament(tokeValue,'https://djangodrf.arifsultani291.digital/products/increament/',id,price)
    getData()
   }
   

   const DecreamentHandler = async (id:number |string,price:string)=>{
    console.log(id,price);
    const tokeValue = token ? token :'';

    await Decreament(tokeValue,'https://djangodrf.arifsultani291.digital/products/decreament/',id,price)
    getData()
   }
  return (
    <div className='cartHolder'>
    <Navbar/>
     <div className='cart'>
    <div className='cartHeader'>
        <h4>Image</h4>
        <h4>Name</h4>
        <h4>price</h4>
        <h4>Quantity</h4>
    </div>
    {data.length ==0 && <p>No Item Added Yet, Refresh the page if you added to the cart for the first time</p>}
    {data.map((item:Product) =>(
       <div className='item' key={item.id}>
       <img className='itemImage' src={`https://djangodrf.arifsultani291.digital/products/${item.product.images[0].image}`}/>
       <h4 style={{color:'white'}}>{item.product.name}</h4>
       <h4 style={{color:'white'}}>${item.price}</h4>
       <div className='quantity'>
        <div className='plus' onClick={increamentHandler.bind(null,item.product.id,item.product.price)}>
        <i className="fa-solid fa-plus"></i>
        </div>
       <p style={{color:'white',marginTop:10}}>{item.quantity}</p>
       <div className='minus' onClick={DecreamentHandler.bind(null,item.product.id,item.product.price)}>
       <i className="fa-solid fa-minus"></i>
       </div>
       </div>
     </div>
      
    ))}
     
   
    </div>
    </div>
  
  )
}

export default Cart
